

import service from '@/utils/axios';

export function getTopArticle() {
    return service({
        url: '/admin/api/v1/dxsf/official/getTopArticle',
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js